export const SET_MENU_DATA = 'SET_MENU_DATA';
export const UPDATE_MENU_ITEM_STATUS = 'UPDATE_MENU_ITEM_STATUS';
export const DELETE_MENU_CATEGORY = 'DELETE_MENU_CATEGORY';